export enum ListingActivities {
    Picked = 1,
    Liked = 2,
    Disliked = 3,
    Shown = 4
}